import { render, staticRenderFns } from "./ImgFilePreview.vue?vue&type=template&id=fab8fd14&lang=pug"
import script from "./ImgFilePreview.vue?vue&type=script&lang=js"
export * from "./ImgFilePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports